import { render, staticRenderFns } from "./ReleaseNotes.vue?vue&type=template&id=f81785ae&scoped=true&"
import script from "./ReleaseNotes.vue?vue&type=script&lang=js&"
export * from "./ReleaseNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81785ae",
  null
  
)

export default component.exports